import { CUSTOM_EVENT_PREFIX, SERVER_CUSTOM_EVENT_PREFIX } from '../../constants/dataFieldKeys/reportColumnKeys';
import { getMetaDataFromColumnKey } from '../../parsers/dynamicCalculations';
import { isCustomEvent } from './isCustomEvent';

export const getDynamicCalculationColumnDataFieldKey = (key: string) => {
  const { eventName, calculationId, prefix } = getMetaDataFromColumnKey(key);

  if (!eventName) {
    return key;
  }

  if (isCustomEvent(eventName)) {
    const customEventName = eventName.slice(CUSTOM_EVENT_PREFIX.length);
    return `${prefix}__${calculationId}__${SERVER_CUSTOM_EVENT_PREFIX}${customEventName}`;
  }

  return `${prefix}__${calculationId}__${eventName}`;
};
